//src/components/admin/pagebuilder/Block

import React from "react";

export default function Block({ title, description, onEdit }) {
  return (
    <div
      onClick={onEdit}
      className="border-2 border-dashed border-slate-300 rounded-xl p-6 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer transition"
    >
      <h3 className="font-bold text-lg">
        {title || "Componente"}
      </h3>
      <p className="text-sm text-slate-500">{description}</p>
      <span className="text-xs text-indigo-600 font-semibold mt-2 inline-block">
        Clique para editar
      </span>
    </div>
  );
}
